import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { VerifyEmailView } from '@/features/auth/components/verify-email-view';

const verifyEmailSearchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute('/_verify-email/verify-email')({
  validateSearch: verifyEmailSearchSchema,
  component: VerifyEmailPage,
});

function VerifyEmailPage() {
  const { token } = Route.useSearch();
  return <VerifyEmailView token={token} />;
}
